"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.movePeriodOnPeriod = void 0;
const _1 = require(".");
/**
 * Period上でPeriodを動かす
 * @param targetPeriod 動かすPeriod
 * @param parentPeriod 親のPeriod
 * @param moveLengthMin 動かす分
 * @param config config
 * @returns 移動後のPeriod
 */
const movePeriodOnPeriod = (targetPeriod, parentPeriod, moveLengthMin) => {
    const periodSlide = targetPeriod.slideMinutes(moveLengthMin);
    return (0, _1.clampPeriod)(periodSlide, parentPeriod);
};
exports.movePeriodOnPeriod = movePeriodOnPeriod;
//# sourceMappingURL=movePeriodOnPeriod.js.map